import styled from "styled-components";

export const MainHeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #111823;

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 32px;
    max-width: 100%;
    margin: 0 auto;
    gap: 24px;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 12px 16px;
      gap: 12px;
    }
  }

  .header-tabs {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      width: 100%;
      overflow-x: auto;
      flex-wrap: nowrap;
      padding-bottom: 4px;
      gap: 8px;
      
      &::-webkit-scrollbar {
        height: 2px;
      }
      
      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 2px;
      }
    }
  }

  .logo-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    transition: background 0.3s ease;
    
    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }

  .header-logo {
    height: 32px;
    width: auto;
    object-fit: contain;

    @media (max-width: 768px) {
      height: 28px;
    }
  }

  .tab-button {
    position: relative;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 6px;
    white-space: nowrap;
    
    &:hover {
      color: rgba(255, 255, 255, 0.9);
      background: rgba(255, 255, 255, 0.05);
    }

    &.active {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.1);
    }

    @media (max-width: 768px) {
      font-size: 13px;
      padding: 6px 12px;
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: 768px) {
      width: 100%;
      justify-content: space-between;
    }
  }

  .connect-spotify-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: linear-gradient(135deg, #1DB954 0%, #1ED760 100%);
    color: white;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(29, 185, 84, 0.4);
    }

    &:active {
      transform: scale(0.98);
    }

    @media (max-width: 768px) {
      font-size: 12px;
      padding: 6px 12px;
      gap: 6px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .search-bar-wrapper {
    display: flex;
    align-items: center;
    position: relative;

    @media (max-width: 768px) {
      flex: 1;

      &::before {
        display: none;
      }
    }
  }

  .notification-button {
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      top: 8px;
      right: 8px;
      width: 6px;
      height: 6px;
      background: #ff4d4f;
      border-radius: 50%;
      display: none; // Show when there are notifications
    }

    &.has-notifications::after {
      display: block;
    }
  }

  .profile-avatar {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    border-radius: 8px;
    transition: background 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
  }

  .avatar-icon {
    border: 2px solid rgba(255, 255, 255, 0.1);
    transition: border-color 0.3s ease;
    overflow: hidden;
    flex-shrink: 0;

    &.ant-avatar-image {
      background: transparent;
    }

    .ant-avatar-image {
      width: 100%;
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &:hover {
      border-color: rgba(59, 130, 246, 0.5);
    }
  }

  .avatar-text {
    color: #ffffff;
    background-color: #111823;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.3s ease;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.08);
    }

    &:active {
      transform: scale(0.95);
    }

    @media (max-width: 768px) {
      padding: 6px;
      
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .profile-button {
    margin-left: 4px;
    
    &:hover {
      background: rgba(59, 130, 246, 0.15);
      color: #3b82f6;
    }
  }

  // Override SearchBar styles for header integration
  .search-bar-wrapper {
    .ant-input-affix-wrapper {
      background: rgba(255, 255, 255, 0.12) !important;
      border: 1px solid rgba(255, 255, 255, 0.15) !important;
      width: 320px !important;
      height: 40px !important;
      border-radius: 8px !important;
      transition: all 0.3s ease !important;

      &:hover {
        border-color: rgba(255, 255, 255, 0.3) !important;
        background: rgba(255, 255, 255, 0.15) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
      }

      &:focus-within {
        border-color: rgba(255, 255, 255, 0.3) !important;
        background: rgba(255, 255, 255, 0.18) !important;
        box-shadow: 0 0 0 2px rgba(29, 185, 84, 0.2) !important;
      }
    }

    .ant-input-suffix {
      padding: 0px 8px 0px 8px;
    }

    @media (max-width: 768px) {
      max-width: none;
      flex: 1;
      margin-right: 0;

      .ant-input-affix-wrapper {
        width: 100% !important;
        height: 36px !important;
      }
    }

    @media (max-width: 480px) {
      .ant-input-affix-wrapper {
        width: 100% !important;
        height: 34px !important;
      }
    }
  }
`;

export const NotificationDropdownStyles = `
  .notification-dropdown-content {
    padding: 16px 12px;
    text-align: center;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notification-empty-text {
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    margin: 0;
    font-weight: 400;
    font-family: Poppins;
  }
`;
